import { Tooltip } from "@mui/material";
import React from "react";

interface MetricItemProps {
  value: string | React.ReactNode;
  tooltip: string;
}

export default function MetricItem({ value, tooltip }: MetricItemProps) {
  return (
    <Tooltip title={tooltip} arrow>
      <span>{value}</span>
    </Tooltip>
  );
}
